import apiClient from "./core/ApiClient";
import { TransfersListResponse } from "src/api/TransfersListResponse";
import { Transfer } from 'src/api/Transfer';
import { TransfersFindResponse } from "@/api/TransfersFindResponse";
import { TransfersStoreRequest } from "@/api/TransfersStoreRequest";

const root = "/api/funds/transfers";

const listAll = (): Promise<TransfersListResponse> =>
  apiClient.get<TransfersListResponse>(root);

const queryParams = (year?: number, projectId?: number, partnerId?: number): string => {
    const params = new URLSearchParams();
    if (year) {
      params.append('year', year.toString());
    }
    if (projectId) {
      params.append('project_id', projectId.toString());
    }
    if (partnerId) {
      params.append('partner_id', partnerId.toString()); 
    }
    return params.toString();
};
const query = (year?: number, projectId?: number, partnerId?: number): Promise<TransfersListResponse> =>
    apiClient.get<TransfersListResponse>(`${root}?${queryParams(year, projectId, partnerId)}`);

const find = (id: number): Promise<Transfer> =>
  apiClient.get<TransfersFindResponse>(`${root}/${id}`).then(r => r.transfer);

const fundSourceNames = (): Promise<string[]> =>
  apiClient.get<string[]>(`${root}/sources`);

const add = (transfer: Transfer): Promise<void> => {
  const payload: TransfersStoreRequest = {
    entry: transfer,
  };
  return apiClient.post<TransfersStoreRequest, void>(root, payload);
};

const update = (transfer: Transfer): Promise<void> => {
  const payload: TransfersStoreRequest = {
    entry: transfer,
  };
  return apiClient.put<TransfersStoreRequest, void>(root, payload);
};
const remove = (id: number): Promise<void> => apiClient.delete<void>(`${root}/${id}`);

export const transferService = {
  listAll,
  queryParams,
  query,
  find,
  fundSourceNames,
  add,
  update,
  remove,
};
